interface Props {
  yandexVerification?: string
  googleVerification?: string
}

/**
 * Функция получения meta информации о страницах для корневого app.vue
 * @param yandexVerification - верификационный токен yandex
 * @param googleVerification - верификационный токен google
 */
export const getAppMetaInfo = ({
  yandexVerification = '',
  googleVerification = '',
}: Props) => {
  return [
    { name: 'yandex-verification', content: yandexVerification },
    { name: 'google-site-verification', content: googleVerification },
  ]
}
